import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { timezoneStringLabel } from '../../../../dateUtils';

function InterviewTimezone({ timezoneStr, dateStr = '' }) {
  let date = new Date(dateStr);
  if (isNaN(date.getTime())) { // Check if the date is invalid
    date = new Date(); // Assign the current date if invalid
  }

  return (
    <Fragment>{timezoneStringLabel(timezoneStr, date)}</Fragment>
  );
}

InterviewTimezone.propTypes = {
  timezoneStr: PropTypes.string.isRequired,
  dateStr: PropTypes.string,
};

InterviewTimezone.defaultProps = {
  dateStr: '',
};

export default InterviewTimezone;
